import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "./axios";
import { ToastContainer, toast } from 'react-toastify';


import { handleErrorToast, sortProjects } from "../../utils/ReusableFunctions";
import { AddwithWhiteCircle, DeleteDustbin, Tripledot, UpdatePencil, DropdownArrowOption, Attachment } from "../../utils/ReusableSVGs";
import { useNavigate } from "react-router-dom";

const AddSiteSubcompanys = ({ getSiteDeop }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            title: ""
        })
        setErrors({});
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        title: "",
        company_name: "",
        company_address: '',
        company_number: '',
        company_gst: "",
        company_logo: "",
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["title", "company_name", "company_address", "company_number", "company_gst", "company_logo"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const generateRandomString = () => {
        const chars =
            "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.from(
            { length: 8 },
            () => chars[Math.floor(Math.random() * chars.length)]
        ).join("");
    };
    const createCustomFile = (originalFile) => {
        const randomCode = generateRandomString();
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
        return new File([originalFile], customFileName, {
            type: originalFile.type,
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        // if (formData.is_internal_source) {
        //     newerror.is_internal_source = "Is internal source is required "
        // }
        // setErrors(newerror)
        if (Object.keys(newerror).length === 0) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                const formDataToSend = new FormData();

                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "company_logo") {
                        formDataToSend.append(key, formData[key]);
                    }
                });
                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.company_logo;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });


                const customFile = createCustomFile(formData.company_logo);
                if (formData.company_logo) {
                    formDataToSend.append("company_logo", customFile2);
                }

                let res = await axios.post(
                    `${BASE_URL}/configuration/subcompany/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                console.log(res);
                if (res.status === 200) {
                    setShow(false);
                    setFormData(() => Object.keys(formData).reduce((acc, key) => {
                        acc[key] = '';
                        return acc;
                    }, {}));
                    await getSiteDeop();
                    window.location.reload()
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                // setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button title="Add Sub Company" className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "}Sub Company
            </button>


            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>Add Sub Company</Modal.Title>
                </Modal.Header>
                {/* <Modal.Header closeButton>
                <Modal.Title>Request Leave</Modal.Title>
              </Modal.Header> */}
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            <div title="title" className="flex-column">
                                <label
                                    htmlFor="title"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Title
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="title"
                                    name="title"
                                    placeholder="Title"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">
                                        {errors.title}
                                    </span>
                                )}
                            </div>
                            <div title="company_name" className="flex-column">
                                <label
                                    htmlFor="company_name"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Name
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_name"
                                    name="company_name"
                                    placeholder="Company Name"
                                    onChange={handleInputChange}
                                    value={formData.company_name}
                                    className={`form-input ${errors.company_name
                                        ? "error"
                                        : inputState.company_name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_name && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_name}
                                    </span>
                                )}
                            </div>

                            <div title="company_address" className="flex-column">
                                <label
                                    htmlFor="company_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Address
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_address"
                                    name="company_address"
                                    placeholder="Company Address"
                                    onChange={handleInputChange}
                                    value={formData.company_address}
                                    className={`form-input ${errors.company_address
                                        ? "error"
                                        : inputState.company_address
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_address}
                                    </span>
                                )}
                            </div>
                            <div title="company_number" className="flex-column">
                                <label
                                    htmlFor="company_number"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Number
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_number"
                                    name="company_number"
                                    placeholder="company_number"
                                    onChange={handleInputChange}
                                    value={formData.company_number}
                                    className={`form-input ${errors.company_number
                                        ? "error"
                                        : inputState.company_number
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_number && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_number}
                                    </span>
                                )}
                            </div>
                            <div title="company_gst" className="flex-column">
                                <label
                                    htmlFor="company_gst"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Gst Number
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_gst"
                                    name="company_gst"
                                    placeholder="company_gst"
                                    onChange={handleInputChange}
                                    value={formData.company_gst}
                                    className={`form-input ${errors.company_gst
                                        ? "error"
                                        : inputState.company_gst
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_gst && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_gst}
                                    </span>
                                )}
                            </div>
                            <div title="company_logo" className="flex-column">
                                <label
                                    htmlFor="company_logo"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Logo
                                </label>
                                {formData.company_logo && (
                                    <div>
                                        <span>{formData.company_logo.name}</span>

                                        {formData.company_logo && (
                                            <img
                                                src={formData.company_logo}
                                                alt="company_logo Preview"
                                                width={100}
                                            />
                                        )}
                                    </div>
                                )}
                                <input
                                    type="file"
                                    maxLength={100}
                                    id="company_logo"
                                    name="company_logo"
                                    placeholder="company_logo"
                                    onChange={handleInputChange}
                                    // accept=".png,.svg,.jpg,.jpeg"
                                    className={`form-input ${errors.company_logo
                                        ? "error"
                                        : inputState.drawing
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_logo && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_logo}
                                    </span>
                                )}
                            </div>

                            <div className="button-models" style={{ width: "100%" }}>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button   font-weight500    model-button-submit"
                                //   disabled={loading}
                                >
                                    {/* //loading logic */}
                                    Add
                                </button>
                            </div>
                        </div>
                    </form>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const UpdateSiteSubcompanyupdate = ({ i, getSiteSubcompanies }) => {
    console.log(i, "update certificates");
    const [show, setShow] = useState(false);
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        company_name: "",
        company_address: "",
        company_number: "",
        company_gst: "",
        company_logo: "",
    });
    const [originalcompanylogo, setOriginalcompanylogo] = useState(null);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setFormData(i);
        setOriginalcompanylogo(i.company_logo);
    };
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(value);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }

        console.log(newValue);
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));

        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        if (Object.keys(newerror).length === 0) {
            // setErrors(newerrors)
            //   setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const formDataToSend = new FormData();

                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "company_logo") {
                        formDataToSend.append(key, formData[key]);
                    }
                });

                if (
                    formData.company_logo &&
                    formData.company_logo !== originalcompanylogo
                ) {
                    Array.from(formData.company_logo).forEach((file) => {
                        formDataToSend.append("company_logo", formData.company_logo);
                    });
                }
                console.log("FormData to send:", formDataToSend);

                let res = await axios.put(
                    `${BASE_URL}/configuration/subcompany/${formData.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                console.log(res);
                if (res.status === 200) {
                    setShow(false);
                    setFormData(() => Object.keys(formData).reduce((acc, key) => {
                        acc[key] = '';
                        return acc;
                    }, {}));
                    await getSiteSubcompanies();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                // setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Update SubCompany Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {console.log(formData)}
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            <div title="title" className="flex-column">
                                <label
                                    htmlFor="title"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Title
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="title"
                                    name="title"
                                    placeholder="Title"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">
                                        {errors.title}
                                    </span>
                                )}
                            </div>
                            <div title="company_name" className="flex-column">
                                <label
                                    htmlFor="company_name"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Name
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_name"
                                    name="company_name"
                                    placeholder="Company Name"
                                    onChange={handleInputChange}
                                    value={formData.company_name}
                                    className={`form-input ${errors.company_name
                                        ? "error"
                                        : inputState.company_name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_name && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_name}
                                    </span>
                                )}
                            </div>

                            <div title="company_address" className="flex-column">
                                <label
                                    htmlFor="company_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Address
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_address"
                                    name="company_address"
                                    placeholder="Company Address"
                                    onChange={handleInputChange}
                                    value={formData.company_address}
                                    className={`form-input ${errors.company_address
                                        ? "error"
                                        : inputState.company_address
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_address}
                                    </span>
                                )}
                            </div>
                            <div title="company_number" className="flex-column">
                                <label
                                    htmlFor="company_number"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Number
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_number"
                                    name="company_number"
                                    placeholder="company_number"
                                    onChange={handleInputChange}
                                    value={formData.company_number}
                                    className={`form-input ${errors.company_number
                                        ? "error"
                                        : inputState.company_number
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_number && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_number}
                                    </span>
                                )}
                            </div>
                            <div title="company_gst" className="flex-column">
                                <label
                                    htmlFor="company_gst"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Gst Number
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="company_gst"
                                    name="company_gst"
                                    placeholder="company_gst"
                                    onChange={handleInputChange}
                                    value={formData.company_gst}
                                    className={`form-input ${errors.company_gst
                                        ? "error"
                                        : inputState.company_gst
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_gst && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_gst}
                                    </span>
                                )}
                            </div>
                            <div title="company_logo" className="flex-column">
                                <label
                                    htmlFor="company_logo"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Company Logo
                                </label>
                                {formData.company_logo && (
                                    <div>
                                        <span>{formData.company_logo.name}</span>

                                        {formData.company_logo && (
                                            <img
                                                src={formData.company_logo}
                                                alt="company_logo Preview"
                                                width={100}
                                            />
                                        )}
                                    </div>
                                )}
                                <input
                                    type="file"
                                    maxLength={100}
                                    id="company_logo"
                                    name="company_logo"
                                    placeholder="company_logo"
                                    onChange={handleInputChange}
                                    // accept=".png,.svg,.jpg,.jpeg"
                                    className={`form-input ${errors.company_logo
                                        ? "error"
                                        : inputState.drawing
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.company_logo && (
                                    <span className="error-message font-size-text ">
                                        {errors.company_logo}
                                    </span>
                                )}
                            </div>

                            <div className="button-models" style={{ width: "100%" }}>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button   font-weight500    model-button-submit"
                                //   disabled={loading}
                                >
                                    {/* //loading logic */}
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteSiteSubcompany = ({ i, getSiteSubcompanies }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();

        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(`${BASE_URL}/configuration/subcompany/${i.id}/`);

            if (res.status === 200) {
                setShow(false);
                await getSiteSubcompanies();
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Sub-Company {i.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete SubCompany {i.title}
                        <div className="button-models">
                            <button className="model-button   font-weight500    model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>

                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


export {
    AddSiteSubcompanys,
    UpdateSiteSubcompanyupdate,
    DeleteSiteSubcompany,
}